import React from "react";

const Pagination = ({
  page,
  totalPages,
  isMobile,
  handlePageChange,
  getPaginationNumbers,
}) => {
  return (
    <div className="pagination">
      <button onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
        Prev
      </button>
      {getPaginationNumbers(page, totalPages, isMobile).map((p, idx) =>
        p === "..." ? (
          <span
            key={`ellipsis-${idx}`}
            style={{ padding: "0 0.3rem", color: "#aaa" }}
          >
            ...
          </span>
        ) : (
          <button
            key={p}
            className={p === page ? "active" : ""}
            onClick={() => handlePageChange(p)}
          >
            {p}
          </button>
        )
      )}
      <button
        onClick={() => handlePageChange(page + 1)}
        disabled={page === totalPages}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
